<template>
  <div class="page-select-store">
    <div class="top">
      <div class="department-name" v-if="department_name">
        {{ department_name }}
      </div>
      <div class="search-wrapper">
        <input
          placeholder="搜索门店名称"
          class="search-input"
          type="text"
          confirm-type="search"
          v-model="keyword"
          @confirm="search"
        />
        <div class="search-btn" @click="search">搜索</div>
      </div>
    </div>
    <div class="store-list-box">
      <div class="title">门店列表</div>
      <div
        class="store-list"
        v-infinite-scroll="infinite"
        v-infinite-scroll-disabled="is_loading_list"
        v-infinite-scroll-distance="10"
        v-if="list.length"
      >
        <div
          class="store-item"
          v-for="(item, index) in list"
          :key="index"
          @click="goPage(item)"
        >
          <div class="store-name">{{ item.store_name }}</div>
          <div class="address" v-if="item.address">{{ item.address }}</div>
          <div class="store-code">{{ item.store_code }}</div>
          <img
            class="arrow"
            src="https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/arrow_right.png"
          />
          <div class="tag">
            近90天查询{{ item.select_num }}次
            <img
              class="tag-icon"
              src="https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/tag.png"
            />
          </div>
        </div>
      </div>
      <div class="empty-page" v-else>
        <img
          src="https://select-oil-oss.vchangyi.com/wxapp/search-empty-bg.png"
        />
        <div class="tip">暂无门店</div>
      </div>
    </div>

    <div class="dialog" v-if="show">
      <div class="box">
        <div class="title">温馨提示</div>
        <div class="msg">
          该门店近90天选油助手查询次数不足50次，暂无法生成备货推荐报告。请您先推动门店使用选油助手，谢谢！
        </div>
        <div class="btn" @click="show = false">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/apis/maintenance-api.js";
export default {
  name: "store-list",
  data() {
    return {
      page_init: false,
      meta: {
        size: 15,
        page: 1,
      },
      is_loading_list: false, // 列表是否在加载中
      has_more: true, //是否有更多数据
      keyword: "",
      list: [],
      show: false,
      department_name: "",
    };
  },

  created() {
    this.department_name = this.$route.query.department_name;
    const urlParams = new URLSearchParams(window.location.search);
    // 埋点：从小程序进入 && 还没埋点
    if (urlParams.get("source") && !sessionStorage.getItem("hasBuried")) {
      this.fetchList(1);
      // 标记已埋点
      sessionStorage.setItem("hasBuried", "true");
    } else {
      this.fetchList();
    }
  },

  mounted() {
    document.title = "选择门店";
  },

  methods: {
    // 获取列表数据
    async fetchList(is_event) {
      if (this.is_loading_list) return;
      try {
        this.$loading.show();
        this.is_loading_list = true;
        const { code, data, meta, message } = await Api.getStoreListApi({
          store_name: this.keyword,
          dealer_code: this.$route.query.dealer_code,
          customer_id: this.$route.query.customer_id,
          nick_name: this.$route.query.nick_name,
          mobile: this.$route.query.mobile,
          source: this.$route.query.source,
          sign: this.$route.query.sign,
          page: this.meta.page,
          size: this.meta.size,
          is_event: is_event,
        });
        this.$loading.hide();
        this.is_loading_list = false;
        if (code == 0) {
          this.list = [...this.list, ...data];
          this.has_more = this.list.length < meta.total;
          this.page_init = true;
        } else {
          this.$toast.error(message);
        }
      } catch (err) {
        this.$loading.hide();
        this.is_loading_list = false;
        console.log(err.message);
      }
    },

    // 搜索
    search() {
      this.list = [];
      this.page_init = false;
      this.meta.page = 1;
      this.fetchList();
    },

    // 上拉加载
    infinite() {
      console.log("上拉加载～");
      if (!this.has_more || this.is_loading_list) {
        return;
      }
      this.meta.page++;
      this.fetchList();
    },

    goPage(item) {
      // 埋点
      Api.zhendaoClickEventApi({
        store_id: item.id,
        dealer_code: this.$route.query.dealer_code,
        customer_id: this.$route.query.customer_id,
        nick_name: this.$route.query.nick_name,
        mobile: this.$route.query.mobile,
        source: this.$route.query.source,
      });
      if (item.select_num < 50) {
        this.show = true;
      } else {
        this.goZhendao(item.id, item.store_name);
      }
    },

    // 跳转珍岛备货助手
    async goZhendao(mId, mName) {
      try {
        const { code, data, message } = await Api.getZhendaoTokenApi();
        if (code == 0) {
          window.location.href = `https://aiapp.digitalshell.com.cn/app?token=${
            data.token
          }&mId=${mId}&mName=${encodeURIComponent(mName)}`;
        } else {
          this.$toast.error(message);
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.page-select-store {
  background: #fbfbfb;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top {
    padding: 28/100rem 30/100rem 82/100rem 30/100rem;
    background: #fbd42c;
    .department-name {
      height: 44/100rem;
      line-height: 44/100rem;
      font-size: 26/100rem;
      font-weight: bold;
      color: #404040;
      padding-left: 54/100rem;
      background: url("https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/department-icon.png")
        no-repeat left center;
      background-size: 44/100rem 44/100rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 15/100rem;
    }
    .search-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      .search-input {
        flex: 1;
        height: 72/100rem;
        border-radius: 42/100rem;
        padding: 0 30/100rem 0 64/100rem;
        background: #ffffff
          url("https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/search-icon.png")
          no-repeat 20/100rem center;
        background-size: 38/100rem 40/100rem;
        font-size: 22/100rem;
        color: #000000;
      }
      .search-btn {
        font-size: 24/100rem;
        color: #666666;
        margin-left: 12/100rem;
        font-weight: bold;
      }
    }
  }
  .store-list-box {
    background: #fbfbfb;
    border-radius: 40/100rem 40/100rem 0 0;
    margin-top: -58/100rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    padding-bottom: 30/100rem;
    .title {
      font-weight: 600;
      font-size: 22/100rem;
      color: #a6a6a6;
      padding: 25/100rem 30/100rem;
    }
    .store-list {
      flex: 1;
      overflow-y: auto;
      .store-item {
        background: #ffffff;
        box-shadow: 0 12/100rem 32/100rem 0 rgba(207, 207, 207, 0.2);
        border-radius: 24/100rem;
        padding: 30/100rem;
        position: relative;
        margin: 0 30/100rem 30/100rem;
        min-height: 170/100rem;
        .store-name {
          max-width: 350/100rem;
          font-weight: 600;
          font-size: 26/100rem;
          color: #404040;
        }
        .address,
        .store-code {
          max-width: 450/100rem;
          font-size: 22/100rem;
          color: #afafaf;
          word-break: break-all;
        }
        .address {
          margin-top: 20/100rem;
        }
        .store-code {
          margin-top: 10/100rem;
        }
        .arrow {
          width: 22/100rem;
          height: 22/100rem;
          position: absolute;
          right: 36/100rem;
          top: 108/100rem;
        }
        .tag {
          height: 48/100rem;
          line-height: 48/100rem;
          background: #fce9e9;
          border-radius: 24/100rem 10/100rem 0 24/100rem;
          font-weight: 500;
          font-size: 20/100rem;
          color: #dd1d21;
          padding: 0 10/100rem 0 12/100rem;
          position: absolute;
          right: -22/100rem;
          top: 26/100rem;
          .tag-icon {
            width: 22/100rem;
            height: 18/100rem;
            position: absolute;
            bottom: -18/100rem;
            right: 0;
          }
        }
      }
    }
    .empty-page {
      transform: translateY(20vh);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666666;
      line-height: 34/100rem;
      font-size: 24/100rem;
      img {
        width: 133/100rem;
        height: 133/100rem;
        margin-bottom: 34/100rem;
      }
    }
  }
  .dialog {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    .box {
      width: 500/100rem;
      background: #ffffff;
      border-radius: 20/100rem;
      padding: 40/100rem 30/100rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title {
        font-weight: 600;
        font-size: 24/100rem;
        color: #282828;
      }
      .msg {
        font-size: 22/100rem;
        color: #999999;
        line-height: 40/100rem;
        margin: 30/100rem 0;
      }
      .btn {
        width: 350/100rem;
        height: 65/100rem;
        background: #fbce07;
        border-radius: 52/100rem;
        font-weight: 600;
        font-size: 24/100rem;
        color: #404040;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
